import Application from "../../Application";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import IndexesByOrganisationDataReportPresenter, {
  IIndexesByOrganisationDataReportPresenter
} from "../presenter/IndexesByOrganisationDataReportPresenter";

export default class ShowIndexesByCategoryReportInteractor {
  private application: Application;
  private output?: IIndexesByOrganisationDataReportPresenter;
  private getAllOrganisations: GetAllOrganisationsInteractor;

  constructor({ application, getAllOrganisations }: any) {
    this.application = application;
    this.getAllOrganisations = getAllOrganisations;
  }

  private async getOrganisations() {
    return this.getAllOrganisations.execute();
  }

  private async getReferenceLists() {
    return Promise.all([this.getOrganisations()]);
  }

  execute() {
    this.output = IndexesByOrganisationDataReportPresenter({
      application: this.application,
      initialState: {
        organisationId: NaN,
        selectedCategoryId: NaN,
        organisations: [],
        organisationIndexCategories: [],
        data: []
      }
    });
    this.getReferenceLists().then(([organisations]) => {
      this.output?.loadReferenceValues(organisations);
    });
    return this.output;
  }
}
